import { FC } from 'react';
import { DatePicker as AntDatePicker, DatePickerProps as AntDatePickerProps } from 'antd';
import dayjs from 'dayjs';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';

export type DatePickerProps = Omit<AntDatePickerProps, 'value' | 'onChange'> & {
  value?: string | null;
  onChange?: (date: string) => void;
};

export const DatePicker: FC<DatePickerProps> = ({ value, onChange, ...props }) => (
  <StyledDatePicker
    {...props}
    value={value ? dayjs(value) : undefined}
    format={'DD MMMM YYYY'}
    onChange={(date) => {
      onChange?.(date ? date.toISOString() : date);
    }}
  />
);

const StyledDatePicker = styled(AntDatePicker)`
  display: none;
  &&& {
    width: 100%;
    height: 56px;
    border-color: transparent;
    background-color: ${COLORS.systemLight200};
    transition: none;
    padding-inline: 16px;

    input::placeholder {
      color: ${COLORS.systemDark200};
    }

    &:hover,
    &:has(:disabled) {
      background-color: ${COLORS.systemLight300};
    }

    .ant-picker-input {
      cursor: pointer;
    }
  }
`;
